<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <!-- <a-col :md="6" :sm="24" v-if="userType==0 &&!tenantFirmId">
              <a-form-item label="企业品牌">
                <a-select
                  show-search
                  v-model="queryParam.upperId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="6" :sm="24">
              <a-form-item label="分组标题">
                <a-input v-model="queryParam.title" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="列表样式">
                <a-select
                  show-search
                  v-model="queryParam.style"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="0">一列一个</a-select-option>
                  <a-select-option :key="1">一列两个</a-select-option>
                  <a-select-option :key="2">一列三个</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="默认类型">
                <a-select
                  show-search
                  v-model="queryParam.isDefault"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="0">商家自定义</a-select-option>
                  <a-select-option :key="1">系统默认</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态	">
                <a-select
                  show-search
                  v-model="queryParam.status"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="0">隐藏</a-select-option>
                  <a-select-option :key="1">启用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651c:0:c']"
          >
            <a-icon type="plus" />新增
          </a-button>
          <a-button
            type="primary"
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651d:0:d']"
          >
            <a-icon type="edit" />修改
          </a-button>
          <a-button
            type="danger"
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651r:0:r']"
          >
            <a-icon type="delete" />删除
          </a-button>
        </template>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
      />
      <!-- 批量导入 -->
      <UploadAdd ref="uploadAdd" @ok="getList"></UploadAdd>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag color="green" v-if="record.status == 1"> 正常 </a-tag>
          <a-tag color="red" v-if="record.status == 0">隐藏</a-tag>
        </span>
        <span slot="style" slot-scope="text, record">
          {{ record.style == 0 ? '一列一个' : record.style == 1 ? '一列两个' : '一列三个' }}
        </span>
        <span slot="isDefault" slot-scope="text, record">
          {{ record.isDefault == 0 ? '商家自定义' : '系统默认' }}
        </span>
        <span slot="scriptExplanation" slot-scope="text, record">
          <a-tooltip>
            <template #title>
              <div v-html="record.scriptExplanation"></div>
              <!-- 富文本支持 -->
            </template>
            <a> 查看 </a>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a
            @click="$refs.createForm.handleUpdate(record, undefined)"
            v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651d:0:d']"
            v-if="record.isDefault == 0"
          >
            修改
          </a>

          <a-divider
            type="vertical"
            v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651r:0:r']"
            v-if="record.isDefault == 0"
          />
          <a-dropdown v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651r:0:r', '0b0ce7932013a81cc2f02ee93879e651d:0:h']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651r:0:r']" v-if="record.isDefault == 0">
                <a @click="handleDelete(record)" v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651r:0:r']"> 删除 </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651r:0:r']" v-if="record.isDefault == 0">
                <a @click="goDetail(record)" v-hasPermi="['abm-integral:prod:query']">详情 </a>
              </a-menu-item>

              <a-menu-item v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651d:0:h']">
                <a @click="handleStatus(record)" v-hasPermi="['0b0ce7932013a81cc2f02ee93879e651d:0:h']">
                  {{ record.status == 0 ? '恢复' : '隐藏' }}</a
                >
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <goodsDetail ref="goodsDetail" @ok="getList" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj, statusObj } from '@/api/declaration/grouping'
import CreateForm from './modules/CreateForm'
import goodsDetail from './modules/goodsDetail'
import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'
// import UploadAdd from './modules/uploadAdd'
// import Parameter from '../../pressure/parameter'
import UploadAdd from '../../system/tenant/modules/uploadAdd.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Post',
  components: {
    CreateForm,
    UploadAdd,
    goodsDetail,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantFirmId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        status: undefined,
        style: undefined,
        title: undefined,
      },
      columns: [
        {
          title: '分组标题',
          dataIndex: 'title',
          align: 'center',
        },
        // {
        //   title: '列表样式',
        //   dataIndex: 'style	',
        //   scopedSlots: { customRender: 'style' },
        //   align: 'center',
        // },
        {
          title: '类型',
          dataIndex: 'isDefault',
          scopedSlots: { customRender: 'isDefault' },
          ellipsis: true,
          align: 'center',
        },

        {
          title: '状态	',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center',
        },

        {
          title: '排序	',
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '备注	',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    if (!this.isOperate) {
      this.columns.pop()
    }
    this.queryParam.tenantFirmId = this.tenantFirmId
    this.queryParam.tenantId = this.tenantId
    this.getList()
    if (!this.tenantFirmId) {
      // this.getQi()
    }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    goDetail(record) {
      this.$nextTick(() => {
        this.$refs.goodsDetail.init(record, 1)
      })
    },
    // type
    // 点击批量添加设备
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(3)
      })
    },
    // 状态修改
    handleStatusType(row) {
      // row.status = row.status == '0' ? '1' : '0'
      statusObj({ id: row.id })
        .then(() => {
          this.$message.success('操作成功！')
          this.getList()
        })
        .catch(function () {
          row.status = row.status == '0' ? '1' : '0'
        })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {},
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    // 隐藏
    handleStatus(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      const text = row.status == 0 ? '确定恢复此数据么?' : '确定隐藏此数据么?'
      this.$confirm({
        title: text,
        onOk() {
          return statusObj({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/dev/export',
            {
              ...that.queryParam,
            },
            `设备信息${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
